import React from 'react';
import {InboxOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import CourseCard from './CourseCard';
import {FILTER_GROUPS} from '../courses.enums';

/**
 * Пустое состояние каталога.
 *
 * Это не тупик, а точка захвата лида: если человек искал тему и не нашёл её,
 * потребность у него уже сформулирована. Поэтому здесь и подсказка, какой именно
 * фильтр мешает, и три ближайших курса, и переход к заявке с подставленным запросом.
 */
const EmptyState = ({query, rescueFilter, onReset, suggestions, onAskProgram}) => {
    const {t} = useTranslation();

    const rescueLabel = () => {
        if (!rescueFilter) return null;
        const group = FILTER_GROUPS.find((g) => g.key === rescueFilter.groupKey);
        if (!group) return null;
        const names = rescueFilter.codes
            .map((code) => group.options.find((o) => o.code === code))
            .filter(Boolean)
            .map((o) => t(o.labelKey))
            .join(', ');
        return t('coursesPage.empty.hintFilter', {filter: names, count: rescueFilter.count});
    };

    const hint = rescueLabel();

    return (
        <div className={classes.empty}>
            <InboxOutlined className={classes.emptyIcon}/>

            <h3 className={classes.emptyTitle}>
                {query
                    ? t('coursesPage.empty.title', {query})
                    : t('coursesPage.empty.titleNoQuery')}
            </h3>

            {hint && <p className={classes.emptyHint}>{hint}</p>}

            <div className={classes.emptyActions}>
                <button type="button" className={classes.btnGhost} onClick={onReset}>
                    <IntlMessage id="coursesPage.empty.resetAll"/>
                </button>
                <button type="button" className={classes.btnAccent} onClick={onAskProgram}>
                    <IntlMessage id="coursesPage.empty.leadButton"/>
                </button>
            </div>

            {suggestions.length > 0 && (
                <>
                    <h4 className={classes.emptyMaybeTitle}>
                        <IntlMessage id="coursesPage.empty.maybe"/>
                    </h4>
                    <div className={classes.emptyMaybe}>
                        {suggestions.map((course, i) => (
                            <CourseCard key={course.slug} course={course} index={i}/>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default EmptyState;
